import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    login: (credentials, subscriptionId) => {
        return (dispatch) => {
            const body = {
                userName: credentials.username,
                password: credentials.password,
                subscriptionId
            }

            return dispatch({
                [CALL_API]: {
                    endpoint: 'account/login',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOGIN_REQUEST,
                        types.LOGIN_SUCCESS,
                        types.LOGIN_FAILURE
                    ]
                }
            });
        }
    },
    verify: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'account/verify',
                    method: 'GET',
                    types: [
                        types.VERIFY_REQUEST,
                        types.VERIFY_SUCCESS,
                        types.VERIFY_FAILURE
                    ]
                }
            });
        }
    },
    postSsologin: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'account/post-sso-login',
                    method: 'POST',
                    types: [
                        types.POSTSSO_LOGIN_REQUEST,
                        types.POSTSSO_LOGIN_SUCCESS,
                        types.POSTSSO_LOGIN_FAILURE
                    ]
                }
            });
        }
    },
    logout: () => {
        return (dispatch) => {
            return dispatch({
                type: types.LOGOUT_SUCCESS,
                payload: { },
            });
        };
    },
    logoutOnAuthorizationFailure: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'logout',
                    method: 'GET',
                    types: [
                        types.LOGOUT_REQUEST,
                        types.LOGOUT_SUCCESS,
                        types.LOGOUT_FAILURE
                    ]
                }
            });
        }
    },
    setActiveUserSubscriptions: (subscriptions) => ({
        type: types.SET_ACTIVE_USER_SUBSCRIPTIONS,
        subscriptions: subscriptions
    }),
    setSsoTempToken: (token) => ({
        type: types.SET_SSO_TEMP_TOKEN,
        token: token
    }),
    setCurrentSubscription: (subscriptionId, subscriptionName, customerRoleName, hasMultipleLocations) => ({
        type: types.SET_CURRENT_SUBSCRIPTION,
        subscriptionId: subscriptionId,
        subscriptionName: subscriptionName,
        customerRoleName: customerRoleName,
        hasMultipleLocations: hasMultipleLocations
    }),
    forgotUserName: (emailAddress) => {
        return (dispatch) => {
            const body = {
                email: emailAddress,
            };

            return dispatch({
                [CALL_API]: {
                    endpoint: 'account/ForgotUserName',
                    method: 'POST',
                    body: body,
                    types: [
                        types.FORGOT_USERNAME_REQUEST,
                        types.FORGOT_USERNAME_SUCCESS,
                        types.FORGOT_USERNAME_FAILURE
                    ]
                }
            });
        }
    },
    forgotPassword: (username) => {
        return (dispatch) => {
            const body = {
                userName: username,
            };

            return dispatch({
                [CALL_API]: {
                    endpoint: 'account/forgot-password',
                    method: 'POST',
                    body: body,
                    types: [
                        types.FORGOT_PASSWORD_REQUEST,
                        types.FORGOT_PASSWORD_SUCCESS,
                        types.FORGOT_PASSWORD_FAILURE
                    ]
                }
            });
        }
    },
    resetPassword: (userKey, token, oldPassword, password, confirm) => {
        return (dispatch) => {
            const body = {
                userKey: userKey,
                token: token,
                oldPassword: oldPassword,
                password: password,
                passwordConfirmation: confirm
            };

            return dispatch({
                [CALL_API]: {
                    endpoint: 'account/reset-password',
                    method: 'POST',
                    body: body,
                    types: [
                        types.RESET_PASSWORD_REQUEST,
                        types.RESET_PASSWORD_SUCCESS,
                        types.RESET_PASSWORD_FAILURE
                    ]
                }
            });
        }
    },
    checkResetToken: (userKey, token) => {
        return (dispatch) => {
            const body = {
                userKey: userKey,
                token: token
            };

            return dispatch({
                [CALL_API]: {
                    endpoint: 'account/check-reset-token',
                    method: 'POST',
                    body: body,
                    types: [
                        types.CHECK_RESET_TOKEN_REQUEST,
                        types.CHECK_RESET_TOKEN_SUCCESS,
                        types.CHECK_RESET_TOKEN_FAILURE
                    ]
                }
            });
        }
    },
    findUser: (username, subscriptionId) => {
        return (dispatch) => {
            const body = {
                username,
                subscriptionId
            };

            return dispatch({
                [CALL_API]: {
                    endpoint: 'account/username',
                    method: 'POST',
                    body: body,
                    types: [
                        types.GET_USERNAME_REQUEST,
                        types.GET_USERNAME_SUCCESS,
                        types.GET_USERNAME_FAILURE
                    ]
                }
            });
        }
    },
    setRedirectURL: (redirectURL) => ({
        type: types.SET_REDIRECT_URL,
        redirectURL: redirectURL
    }),
    clearLoginWorkflow: () => ({
        type: types.CLEAR_LOGIN_WORKFLOW
    }),
    completeWorkflowStep: (name) => ({
        type: types.COMPLETE_WORKFLOW_STEP,
        name: name
    }),
    getSubscriptionDependentWorkflowSteps: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'account/subscription-dependent-workflow-steps',
                    method: 'GET',
                    types: [
                        types.GET_SUBSCRIPTION_DEPENDENT_WORKFLOW_STEPS_REQUEST,
                        types.GET_SUBSCRIPTION_DEPENDENT_WORKFLOW_STEPS_SUCCESS,
                        types.GET_SUBSCRIPTION_DEPENDENT_WORKFLOW_STEPS_FAILURE
                    ]
                }
            });
        }
    },
    freeTrialSignUp: (signUpData) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'account/free-trial-sign-up',
                    method: 'POST',
                    body: signUpData,
                    types: [
                        types.FREE_TRIAL_SIGN_UP_REQUEST,
                        types.FREE_TRIAL_SIGN_UP_SUCCESS,
                        types.FREE_TRIAL_SIGN_UP_FAILURE
                    ]
                }
            });
        }
    },
    loadFreeTrialSignUpFilters: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'account/free-trial-sign-up-filters',
                    method: 'GET',
                    types: [
                        types.LOAD_FREE_TRIAL_SIGN_UP_FILTERS_REQUEST,
                        types.LOAD_FREE_TRIAL_SIGN_UP_FILTERS_SUCCESS,
                        types.LOAD_FREE_TRIAL_SIGN_UP_FILTERS_FAILURE
                    ]
                }
            });
        }
    }
}
